import { render } from "./GoalGambitGame.vue?vue&type=template&id=60fc96ff&scoped=true"
import script from "./GoalGambitGame.vue?vue&type=script&lang=js"
export * from "./GoalGambitGame.vue?vue&type=script&lang=js"

import "./GoalGambitGame.vue?vue&type=style&index=0&id=60fc96ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60fc96ff"]])

export default __exports__